module.exports = __webpack_public_path__ + "static/media/profilePic.88784425.jpeg";